import axios from 'axios'

export default {
    login({commit}, params){
        return axios.post('/api/background/login', params)
    },
    logout({commit}, params){
        return axios.post('/api/background/logout', params)
    },
    getVerifyCode({commit}, params){
        return axios.post('/api/background/login/code', params)
    },
    // 角色管理
    getRoleList({commit}, params){
        return axios.post('/api/background/role/list', params)
    },
    addRole({commit}, params){
        return axios.post('/api/background/role/add', params)
    },
    modifyRole({commit}, params){
        return axios.post('/api/background/role/modify', params)
    },
    deleteRole({commit}, params){
        return axios.post('/api/background/role/delete', params)
    },
    // 账号管理
    getAccountList({commit}, params){
        return axios.post('/api/background/account/list', params)
    },
    addAccount({commit}, params){
        return axios.post('/api/background/account/add', params)
    },
    modifyAccount({commit}, params){
        return axios.post('/api/background/account/info/set', params)
    },
    deleteAccount({commit}, params){
        return axios.post('/api/background/account/delete', params)
    },
    modifyPassword({commit}, params){
        return axios.post('/api/background/account/password/modify', params)
    },
    // 日志管理
    getLogList({commit}, params){
        return axios.post('/api/background/log/list', params)
    },
}


// WEBPACK FOOTER //
// ./src/vuex/actions/account.js